import { DirectLinkType, type DirectLink } from '@src/domains/direct-links/types/directLink';

export const hasDirectLinkItems = (directLink: DirectLink | null | undefined): boolean =>
  directLink?.type === DirectLinkType.Sale ||
  directLink?.type === DirectLinkType.Cart ||
  directLink?.type === DirectLinkType.Order;
